import { render, staticRenderFns } from "./FichaClinicaSaude.vue?vue&type=template&id=07d93b36&"
import script from "./FichaClinicaSaude.vue?vue&type=script&lang=js&"
export * from "./FichaClinicaSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports